const TESTIMONIALS_CHROXEL_SWIPE_THRESHOLD = 60;
const TESTIMONIALS_CHROXEL_DRAG_RESISTANCE = 0.35;

class TestimonialsChroxelSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.testimonials-chroxel__slide'));
    this.dots = Array.from(this.querySelectorAll('.testimonials-chroxel__dot'));
    this.track = this.querySelector('.testimonials-chroxel__track');
    this.prevButton = this.querySelector('.testimonials-chroxel__arrow--prev');
    this.nextButton = this.querySelector('.testimonials-chroxel__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseFloat(this.dataset.speed) || 6) * 1000;
    this.timer = null;
    this.pointerId = null;
    this.startX = 0;
    this.deltaX = 0;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restart();
      });
    });

    this.prevButton?.addEventListener('click', () => {
      this.goTo(this.current - 1);
      this.restart();
    });

    this.nextButton?.addEventListener('click', () => {
      this.goTo(this.current + 1);
      this.restart();
    });

    this.setupDrag();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  setupDrag() {
    if (!this.track) return;

    this.track.classList.add('is-draggable');
    this.track.addEventListener('pointerdown', this.onPointerDown.bind(this));
    this.track.addEventListener('pointermove', this.onPointerMove.bind(this));
    this.track.addEventListener('pointerup', this.onPointerUp.bind(this));
    this.track.addEventListener('pointercancel', this.onPointerUp.bind(this));
    // Sin esto el navegador arrastra la imagen o el texto en vez de deslizar
    this.track.addEventListener('dragstart', (event) => event.preventDefault());
  }

  onPointerDown(event) {
    // Dejar pasar los clics normales sobre enlaces y botones dentro de la reseña
    if (event.target.closest('a, button')) return;

    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.deltaX = 0;
    this.track.classList.add('is-dragging');
    this.track.setPointerCapture(event.pointerId);
    this.stop();
  }

  onPointerMove(event) {
    if (this.pointerId !== event.pointerId || !this.track.classList.contains('is-dragging')) return;

    this.deltaX = event.clientX - this.startX;
    const slide = this.slides[this.current];
    slide.style.transform = `translateX(${this.deltaX * TESTIMONIALS_CHROXEL_DRAG_RESISTANCE}px)`;
    slide.style.opacity = `${Math.max(0.45, 1 - Math.abs(this.deltaX) / 400)}`;
  }

  onPointerUp(event) {
    if (this.pointerId !== event.pointerId) return;

    const slide = this.slides[this.current];
    slide.style.transform = '';
    slide.style.opacity = '';
    this.track.classList.remove('is-dragging');
    this.pointerId = null;

    if (Math.abs(this.deltaX) > TESTIMONIALS_CHROXEL_SWIPE_THRESHOLD) {
      this.goTo(this.deltaX < 0 ? this.current + 1 : this.current - 1);
    }

    this.deltaX = 0;
    this.restart();
  }

  goTo(index) {
    const previous = this.slides[this.current];
    previous.classList.remove('is-active');
    previous.style.transform = '';
    previous.style.opacity = '';
    this.dots[this.current]?.setAttribute('aria-selected', 'false');
    this.dots[this.current]?.classList.remove('is-active');

    this.current = (index + this.slides.length) % this.slides.length;

    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-selected', 'true');
    this.dots[this.current]?.classList.add('is-active');
  }

  start() {
    if (!this.autoplay) return;
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }
}

customElements.define('testimonials-chroxel-slider', TestimonialsChroxelSlider);
